export enum TableAction {
  Edit = 'edit',
  Remove = 'remove',
  Copy = 'copy',
  View = 'eye',
  Download = 'file-upload',
}
